import { render } from "./sf-progress-percentage-label.vue?vue&type=template&id=5d9bcf27&scoped=true"
import script from "./sf-progress-percentage-label.vue?vue&type=script&lang=js"
export * from "./sf-progress-percentage-label.vue?vue&type=script&lang=js"

import "./sf-progress-percentage-label.vue?vue&type=style&index=0&id=5d9bcf27&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9bcf27"]])

export default __exports__